import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import MutualFundListDisplay from './MutualFundListDisplay';

class MutualFundWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Mutualfunds Screener</title>
          <link rel="canonical" href="https://www.vizfm.com/mutualfund" />
          <meta name="description" content="Mutual Funds Screener for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row><Col>Mutual Funds Screener</Col></Row>
          <Row>
            <Col><MutualFundListDisplay /></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default MutualFundWrap;
